import React, { useState, useEffect } from "react";
import { Box, FormControl, Select, InputLabel, MenuItem, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Tooltip, TextField, IconButton } from "@mui/material";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axiosInstance from "../../../../lib/axios";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { Breadcrumbs, Link } from '@mui/material';
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import TurnedInIcon from '@mui/icons-material/TurnedIn';
import CancelIcon from '@mui/icons-material/Cancel';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const columns = [
    { id: 'RoomTypeName', label: 'RoomType', minWidth: 80 },
    { id: 'RoomBedTypeName', label: 'BedType', minWidth: 80 },
    { id: 'ActBedCount', label: 'Bed Count', minWidth: 80 },
    { id: 'ExtraBed', label: 'Extra Bed', minWidth: 80, editable: true },
    { id: 'BedToSale', label: 'Bed To Sale', minWidth: 80 },
    { id: 'BedRent', label: 'Std Rent', minWidth: 80, editable: true },
    { id: 'actions', label: 'Actions', minWidth: 80 },
];

const BedCategory = () => {
    const { register, watch, setValue } = useForm();
    const [rows, setRows] = useState([]);
    const [PropertyDrp, setPropertyDrp] = useState([]);
    const [UserId] = useState(sessionStorage.getItem("UserId"));
    const [editingRow, setEditingRow] = useState(null);
    const [editedValues, setEditedValues] = useState({});
    const navigate = useNavigate();

    useEffect(() => {
        fetchPropertyData();
    }, []);

    const fetchPropertyData = async () => {
        try {
            const response = await axiosInstance.post(
                `PropertyMst/GetPropertyMstUserwisedrp`,
                {
                    Flag: "",
                    UserId,
                }
            );

            if (response.data.Status === 0) {
                const firstPropId = response.data.Data[0]?.Id;
                setPropertyDrp(response.data.Data);
                setValue("PropId", firstPropId);

                if (firstPropId) {
                    fetchBedCategoryData(firstPropId);
                }
            } else {
                toast.error('Error fetching property data');
            }
        } catch (error) {
            toast.error('Error fetching property data');
        }
    };
    
    const fetchBedCategoryData = async (propId) => {
        const bedCatPayload = {
            PropId: propId,
            Flag: ""
        };

        const bedCatCalPayload = {
            PropId: propId,
            Flag: ""
        };

        try {
            // Call all APIs simultaneously
            const [response] = await Promise.all([
                axiosInstance.post(`BedCalendar/ReteiveBedCat`, {
                    PropId: propId,
                    Flag: ""
                }),
                axiosInstance.post('BedCalendar/InsertBedCat', bedCatPayload),
                axiosInstance.post('BedCalendar/InsertBedCatCal', bedCatCalPayload),
                axiosInstance.post('BedCalendar/UpdateBedCat', bedCatPayload),
                axiosInstance.post('BedCalendar/UpdateBedCatCal', bedCatCalPayload)
            ]);
            // Handle response of ReteiveBedCat
            if (response.data.Status === 0) {
                setRows(response.data.Data);
            } else {
                toast.info(response.data.Message);
                setRows([]);
            }
        } catch (error) {
            toast.error('Error fetching bed category data: ' + error.message);
            setRows([]);
        }
    };

    const handlePropertyChange = async (e) => {
        const propId = e.target.value;
        setValue("PropId", propId);
        if (propId) {
            await fetchBedCategoryData(propId);
        } else {
            setRows([]);
        }
    };

    const handleEditClick = (row, idx) => {
        setEditingRow(idx);
        setEditedValues({
            Id: row.BedCatId,
            ActBedCount: row.ActBedCount,
            ExtraBed: row.ExtraBed,
            BedToSale: row.BedToSale,
            BedRent: row.BedRent,
        });
    };

    const handleCancel = () => {
        setEditingRow(null);
        setEditedValues({});
    };

    const handleInputChange = (e, field) => {
        setEditedValues({
            ...editedValues,
            [field]: e.target.value,
        });
    };

    const handleUpdateSave = async (row, idx) => {
        try {
            const response = await axiosInstance.post("BedCalendar/UpdateBedCatRent", {
                Flag: "",
                BedCatId: editedValues.Id,
                ExtraBed: parseInt(editedValues.ExtraBed) || row.ExtraBed,
                BedRent: parseFloat(editedValues.BedRent) || row.BedRent,
            });

            if (response.data.Status === 0) {
                toast.success('Data updated successfully');

                // Reset editing state
                setEditingRow(null);
                setEditedValues({});

                // Refresh the data by calling fetchBedCategoryData with the current PropId
                const currentPropId = watch('PropId');
                if (currentPropId) {
                    await fetchBedCategoryData(currentPropId);
                }

            } else {
                toast.error('Error updating bed category: ' + response.data.Message);
            }
        } catch (error) {
            toast.error('Error updating bed category: ' + error.message);
        }
    };

    const handleHomeClick = () => {
        navigate('/dashboard');
    };

    const handleBackClick = () => {
        navigate("/masters/property");
    };

    const handleLocationClick = () => {
        navigate('/masters/property');
    };

    return (
        <Box
            sx={{
                maxWidth: "100%",
                overflowX: "hidden",
                backgroundColor: "#f9f9f9",
                minHeight: "80vh",
            }}
        >
            <ToastContainer />
            <Box
                sx={{
                    backgroundColor: '#ffffff',
                    padding: '12px 32px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                    borderRadius: '12px',
                    margin: '10px auto',
                    maxWidth: '95%',
                }}
            >
                <Breadcrumbs aria-label="breadcrumb" separator="›" sx={{ fontSize: '16px' }}>
                    <Link onClick={handleHomeClick} underline="hover" color="#635bff" sx={{ cursor: 'pointer' }}>
                        Home
                    </Link>
                    <Typography color="#635bff" onClick={handleLocationClick} sx={{ cursor: 'pointer', fontWeight: 'bold' }}>
                        Property
                    </Typography>
                    <Typography color="text.primary" sx={{ fontWeight: 'bold' }}>Bed Category</Typography>
                </Breadcrumbs>
            </Box>
            <Paper
                sx={{
                    width: "100%",
                    overflow: "hidden",
                    margin: "10px auto",
                    borderRadius: "12px",
                    boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
                    padding: "5px",
                    marginX: "auto",
                    minHeight: '80vh',
                }}
            >
                <Box sx={{ maxWidth: { xs: '100%', md: '100%' }, overflowX: 'hidden', backgroundColor: '#f9f9f9' }}>
                    <Paper
                        sx={{
                            maxWidth: { xs: '100%', md: '70%' },
                            overflow: "hidden",
                            margin: "0 auto",
                            border: "1px solid lightgray",
                            padding: "10px",
                            minHeight: '50vh',
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                mb: 2,
                            }}
                        >
                            <Typography
                                variant="h5"
                                sx={{
                                    fontSize: { xs: "24px", sm: "18px", md: "24px" },
                                    background: 'linear-gradient(90deg, #9655d6ff 0%, #2455aaff 100%)',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',
                                    textShadow: '1px 1px 2px rgba(0,0,0,0.1)',
                                    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
                                }}
                            >
                                Bed Category
                            </Typography>

                            <Tooltip title="Previous Page" arrow>
                                <IconButton
                                    onClick={handleBackClick}
                                    sx={{
                                        backgroundColor: '#635bff',
                                        borderRadius: '50%',
                                        width: 35,
                                        height: 35,
                                        '&:hover': { backgroundColor: '#635bff' },
                                        boxShadow: 3,
                                    }}
                                >
                                    <ArrowBackIcon sx={{ color: 'white' }} />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        <FormControl variant="filled" fullWidth className="custom-select">
                            <InputLabel id="companyName-select-label">
                                <span>
                                    Property <span style={{ color: "red" }}>*</span>
                                </span>
                            </InputLabel>
                            <Select
                                labelId="companyName-select-label"
                                id="PropId"
                                name="PropId"
                                value={watch('PropId') || ''}
                                className="custom-textfield"
                                {...register('PropId')}
                                onChange={handlePropertyChange}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 200,
                                            overflow: "auto",
                                        },
                                    },
                                }}
                            >
                                {PropertyDrp.length > 0 &&
                                    PropertyDrp.map((type) => (
                                        <MenuItem key={type.Id} value={type.Id}>
                                            {type.Name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>

                        <TableContainer
                            sx={{
                                marginTop: "10px",
                                width: "100%",
                                maxHeight: "390px",
                                overflow: "auto",
                            }}
                        >
                            <Table stickyHeader aria-label="sticky table">
                                <TableHead>
                                    <TableRow
                                        sx={{
                                            "& > th": {
                                                padding: "2px 10px",
                                                fontWeight: "bold",
                                                bgcolor: '#d5d8e7ff',
                                                color: "#333",
                                            },
                                        }}
                                    >
                                        {columns.map((column) => (
                                            <TableCell
                                                key={column.id}
                                                style={{ width: column.minWidth }}
                                            >
                                                <Typography variant="subtitle1">
                                                    {column.label}
                                                </Typography>
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, idx) => (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={idx}
                                            sx={{ "& > td": { padding: "2px 6px 2px 10px" } }}
                                        >
                                            {columns.map((column) => {
                                                const isEditable = ['ExtraBed', 'BedRent'].includes(column.id);
                                                if (column.id === 'actions') {
                                                    return (
                                                        <TableCell key="actions">
                                                            {editingRow === idx ? (
                                                                <Tooltip title='Save' arrow>
                                                                    <IconButton onClick={() => handleUpdateSave(row, idx)}>
                                                                        <TurnedInIcon sx={{ fontSize: 20, color: '#23740eff' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            ) : (
                                                                <Tooltip title='Edit' arrow>
                                                                    <IconButton onClick={() => handleEditClick(row, idx)}>
                                                                        <EditIcon sx={{ fontSize: 20, color: '#1976d2' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                            {editingRow === idx && (
                                                                <Tooltip title='Cancel' arrow>
                                                                    <IconButton onClick={handleCancel}>
                                                                        <CancelIcon sx={{ fontSize: 20, color: '#d21919ff' }} />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            )}
                                                        </TableCell>
                                                    );
                                                }
                                                return (
                                                    <TableCell key={column.id}>
                                                        {isEditable && editingRow === idx && !['ActBedCount', 'BedToSale'].includes(column.id) ? (
                                                            <TextField
                                                                variant="outlined"
                                                                size="small"
                                                                type="number"
                                                                value={editedValues[column.id] ?? row[column.id] ?? ''}
                                                                onChange={(e) => handleInputChange(e, column.id)}
                                                                // disabled={['ActBedCount', 'BedToSale'].includes(column.id)}
                                                                inputProps={{
                                                                    style: { padding: '4px 8px', fontSize: '14px' }
                                                                }}
                                                            />
                                                        ) : (
                                                            row[column.id]
                                                        )}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>
                </Box>
            </Paper>
        </Box>
    );
};

export default BedCategory;